import { render, staticRenderFns } from "./AmountChange.vue?vue&type=template&id=d12e788a&scoped=true"
import script from "./AmountChange.vue?vue&type=script&lang=js"
export * from "./AmountChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d12e788a",
  null
  
)

export default component.exports